var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowtail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 20,
    viewBox: "0 0 57 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9999 11.998L44.7966 12.0224V16.0041H40.7219V20H32.5808V16.0163H36.6327V12.0224H40.7219V7.99592H36.6576V4.01225H32.5684V0H40.697V4.01225H44.7841V8.01429H56.9999V11.998Z",
    fill: "#E0AA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6535 12.1V8.01429H28.5V4.01225H24.3983V0H16.2593V3.98163H20.3464V7.99592H24.3983V12.0224H20.3589V16.0163H16.2717V20H24.4107V16.0163H28.4875V11.998L32.6535 12.1Z",
    fill: "#E0AA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3963 12.1V8.01429H12.2407V4.01225H8.139V0H0V3.98163H4.08922V7.99592H8.139V12.0224H4.10168V16.0163H0.0124545V20H8.15146V16.0163H12.2282V11.998L16.3963 12.1Z",
    fill: "#E0AA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 20,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowtail);
export default __webpack_public_path__ + "static/media/arrowtail.11b7f7146c957308cb19b965f890bd11.svg";
export { ForwardRef as ReactComponent };